import './App.css';
import { Outlet } from 'react-router-dom';
import Box from '@mui/material/Box';
import * as Sentry from '@sentry/react';

import { ToastContainer } from 'react-toastify';
import { QueryClientProvider } from '@tanstack/react-query';
import { AppProvider } from './context/AppContext';
import { SocketProvider } from './context/SocketContext';
import client from './utils/react-query/client';

import 'react-toastify/dist/ReactToastify.css';

const environment =
  window.location.hostname === 'app.getporter.io'
    ? 'production'
    : 'development';

Sentry.init({
  dsn: 'https://85234bff49d2564fccf708730e9b3659@o4509566870487040.ingest.us.sentry.io/4509566871601152',
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  integrations: [Sentry.browserTracingIntegration()],
  // Tracing
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ['localhost', /^https:\/\/getporter\.io\/api/],
  environment,
});

export default function App() {
  return (
    <div className="App">
      <Box className="app-content">
        <QueryClientProvider client={client}>
          <AppProvider>
            <SocketProvider>
              <ToastContainer
                position="top-center"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="colored"
              />
              <Outlet />
            </SocketProvider>
          </AppProvider>
        </QueryClientProvider>
      </Box>
    </div>
  );
}
